








































import { Vue, Component, Mixins } from "vue-property-decorator";

import OrderSettleType from "./charts/order_settle_type.vue";
import OrderType from "./charts/order_type.vue";
import UserType from "./charts/user_type.vue";
import UserTag from "./charts/user_tag.vue";
import UserTypeOrder from "./charts/user_type_order.vue";
import UserTagOrder from "./charts/user_tag_order.vue";

@Component({
  components: {
    OrderSettleType,
    OrderType,
    UserType,
    UserTag,
    UserTypeOrder,
    UserTagOrder
  }
})
export default class extends Mixins() {}
